import { Routes } from '@angular/router';
import { LoginComponent } from './pages/auth/login/login.component';
import { RegisterComponent } from './pages/auth/register/register.component';
import { authGuard } from './core/guards/auth.guard';
import { LandingPageComponent } from './pages/auth/landing-page/landing-page.component'; 
import { AuthPageComponent } from './pages/auth/auth-page/auth-page.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () => import('./../app/core/layout/admin.routes'),
  },

  {
    path: 'old-login',
    component: LoginComponent,
  },
  {
    path: 'login',
    component: AuthPageComponent,
  },
  {
    path: 'landing-page',
    component: LandingPageComponent,
  },
  { path: 'register', component: RegisterComponent },
];
